export const DEFAULT_DESCRIPTION =
    'Type Network offers a curated selection of typefaces from quality ' +
    'foundries for use across desktop, web, apps, and more.';